import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import Select from "react-select";

// reactstrap components
import { Row, Col, Card, CardBody, FormGroup, Input, Label, Button } from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { showMessage, showQuestion } from "../../services/message.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";
import {
  ListarCorreioInterno,
  ExcluirCorreioInterno,
} from "../../services/correio_interno_service.js";

// views
import CadastroCorreioInternoForm from "./CadastroCorreioInternoForm.jsx";

//Context
import { useAuth } from "../../context/auth.js";

const options_tipoEnvio = [
  { value: "", label: "Todos" },
  { value: "EMAIL", label: "E-mail" },
  { value: "INTERNO", label: "Interno" },
  { value: "AMBOS", label: "Ambos" },
];

const options_status = [
  { value: "", label: "Todos" },
  { value: "RASCUNHO", label: "Rascunho" },
  { value: "PROCESSANDO", label: "Processando" },
  { value: "ENVIADO", label: "Enviado" },
  { value: "ERRO", label: "Erro" },
];

const DATA_FILTRO_ANO_MIN = 1900;
const DATA_FILTRO_ANO_MAX = 9999;

const descricaoTipoEnvio =(tipoEnvio) => {
  const opcao = options_tipoEnvio.find((o) => o.value === tipoEnvio);
  return opcao ? opcao.label : tipoEnvio;
};

const descricaoStatus = (status) => {
  const opcao = options_status.find((o) => o.value === status);
  return opcao ? opcao.label : status;
};

export default function CadastroCorreioInternoLista() {
  const { setLoading } = useAuth();

  const [permiteEditar, set_permiteEditar] = useState(false);
  const [showDetail, set_showDetail] = useState(false);
  const [rowEdit, set_rowEdit] = useState(null);
  const [list_table, set_list_table] = useState([]);
  const [totalRegistros, set_totalRegistros] = useState(0);

  const [filtro_titulo, set_filtro_titulo] = useState("");
  const [filtro_tipoEnvio, set_filtro_tipoEnvio] = useState(options_tipoEnvio[0]);
  const [filtro_status, set_filtro_status] = useState(options_status[0]);
  const [filtro_dataInicio, set_filtro_dataInicio] = useState("");
  const [filtro_dataFim, set_filtro_dataFim] = useState("");
  const [pagina, set_pagina] = useState(1);
  const registrosPorPagina = 20;

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  };

  const handleEdit = (rowData) => {
    set_rowEdit(rowData);
    set_showDetail(true);
  };

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList(pagina);
  };

  const handleDelete = (rowData) => {
    if (rowData.status !== "RASCUNHO") {
      showMessage("Atenção", "Somente avisos em rascunho podem ser excluídos.", "warning", null);
      return;
    }

    showQuestion("Atenção", `Deseja excluir o aviso "${rowData.titulo}"?`, "question", function (result) {
      if (!result) return;

      setLoading(true);
      ExcluirCorreioInterno(rowData.correioInterno_Id)
        .then(() => {
          showMessage("Aviso", "Aviso excluído com sucesso!", "success", null);
          loadList(pagina);
        })
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    });
  };

  const dataFiltroValida = (data) => {
    if (!data) return true;
    const ano = parseInt(data.substring(0, 4), 10);
    return ano >= DATA_FILTRO_ANO_MIN && ano <= DATA_FILTRO_ANO_MAX;
  };

  const loadList = (_pagina) => {
    if (!dataFiltroValida(filtro_dataInicio) || !dataFiltroValida(filtro_dataFim)) {
      showMessage("Atenção", "Informe uma data de cadastro válida.", "warning", null);
      return;
    }
    if (filtro_dataInicio && filtro_dataFim && filtro_dataInicio > filtro_dataFim) {
      showMessage("Atenção", "A data inicial deve ser menor ou igual à data final.", "warning", null);
      return;
    }

    setLoading(true);
    ListarCorreioInterno({
      titulo: filtro_titulo,
      tipoEnvio: filtro_tipoEnvio ? filtro_tipoEnvio.value : "",
      status: filtro_status ? filtro_status.value : "",
      dataCadastroInicio: filtro_dataInicio,
      dataCadastroFim: filtro_dataFim,
      pagina: _pagina,
      registrosPorPagina: registrosPorPagina,
    })
      .then((result) => {
        set_list_table(result.data.registros || []);
        set_totalRegistros(result.data.totalRegistros || 0);
        set_pagina(result.data.pagina || 1);
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleFiltrar = () => {
    loadList(1);
  };

  const handleLimparFiltros = () => {
    set_filtro_titulo("");
    set_filtro_tipoEnvio(options_tipoEnvio[0]);
    set_filtro_status(options_status[0]);
    set_filtro_dataInicio("");
    set_filtro_dataFim("");
  };

  const totalPaginas = Math.max(1, Math.ceil(totalRegistros / registrosPorPagina));

  useEffect(() => {
    ValidaAcessoFuncionalidadeAcao("CadastroCorreioInterno.Editar", function (result) {
      set_permiteEditar(result);
    });
    loadList(1);
  }, []);

  return (
    <>
      {!showDetail && (
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label>Título</Label>
                        <Input
                          type="text"
                          value={filtro_titulo}
                          maxLength={200}
                          onChange={(e) => set_filtro_titulo(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="2">
                      <FormGroup>
                        <Label>Tipo de envio</Label>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          value={filtro_tipoEnvio}
                          onChange={set_filtro_tipoEnvio}
                          options={options_tipoEnvio}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="2">
                      <FormGroup>
                        <Label>Status</Label>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          value={filtro_status}
                          onChange={set_filtro_status}
                          options={options_status}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="2">
                      <FormGroup>
                        <Label>Cadastro de</Label>
                        <Input
                          type="date"
                          value={filtro_dataInicio}
                          min="1900-01-01"
                          max="9999-12-31"
                          onChange={(e) => set_filtro_dataInicio(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="2">
                      <FormGroup>
                        <Label>Cadastro até</Label>
                        <Input
                          type="date"
                          value={filtro_dataFim}
                          min="1900-01-01"
                          max="9999-12-31"
                          onChange={(e) => set_filtro_dataFim(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" className="text-right">
                      <Button color="gray" onClick={handleLimparFiltros}>
                        Limpar
                      </Button>
                      <Button color="success" onClick={handleFiltrar}>
                        <i className="fa fa-search"></i> Filtrar
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <button
                type="button"
                disabled={!permiteEditar}
                onClick={handleAdd}
                className="btn btn-secundary"
              >
                <i className="fa fa-plus"></i> Novo Aviso
              </button>
              <MaterialTable
                style={{ minHeight: "auto" }}
                title=""
                columns={[
                  { title: "Título", field: "titulo" },
                  {
                    title: "Tipo de envio",
                    field: "tipoEnvio",
                    render: (rowData) => descricaoTipoEnvio(rowData.tipoEnvio),
                  },
                  {
                    title: "Status",
                    field: "status",
                    render: (rowData) => descricaoStatus(rowData.status),
                  },
                  {
                    title: "Cadastro",
                    field: "dataCadastro",
                    render: (rowData) =>
                      rowData.dataCadastro
                        ? new Date(rowData.dataCadastro).toLocaleDateString("pt-BR")
                        : "",
                  },
                  {
                    title: "Envio",
                    field: "dataEnvio",
                    render: (rowData) =>
                      rowData.dataEnvio
                        ? new Date(rowData.dataEnvio).toLocaleDateString("pt-BR")
                        : "",
                  },
                  { title: "Destinatários", field: "totalDestinatarios" },
                ]}
                data={list_table}
                isLoading={false}
                options={{
                  ...table_style,
                  filtering: false,
                  paging: false,
                  exportButton: true,
                }}
                actions={[
                  {
                    icon: "edit",
                    tooltip: "Abrir Aviso",
                    onClick: (event, rowData) => handleEdit(rowData),
                  },
                  (rowData) => ({
                    icon: "delete",
                    tooltip: "Excluir Aviso",
                    disabled: !permiteEditar || rowData.status !== "RASCUNHO",
                    onClick: (event, row) => handleDelete(row),
                  }),
                ]}
                localization={table_translate}
              />
              <Row className="mt-2">
                <Col md="6">
                  <small>
                    {totalRegistros} registro(s) — página {pagina} de {totalPaginas}
                  </small>
                </Col>
                <Col md="6" className="text-right">
                  <Button color="gray" disabled={pagina <= 1} onClick={() => loadList(pagina - 1)}>
                    Anterior
                  </Button>
                  <Button
                    color="gray"
                    disabled={pagina >= totalPaginas}
                    onClick={() => loadList(pagina + 1)}
                  >
                    Próxima
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
      {showDetail && (
        <CadastroCorreioInternoForm
          item={rowEdit}
          permiteEditar={permiteEditar}
          handleReturn={handleReturn}
        />
      )}
    </>
  );
}
